import { connect } from 'react-redux';
import { isCallConnected } from 'utils/call-utils';
import { mediaSelectors, streamActions, callSelectors, callActions } from '@lifesize/nucleus';
import AudioButton from 'components/AudioButton/AudioButton';
import _get from 'lodash/get';
import { audioUnmuteByUser } from 'actions/Call';

const mapDispatchToProps = dispatch => ({
  onSwitchToComputerAudio: () => {
    dispatch(callActions.enableFarEndAudio());
    dispatch(streamActions.setAudioMuteState(false));
  },
  onAudioMuteClick: (mute,  isMutedByServer) => {
    if(isMutedByServer) dispatch(audioUnmuteByUser(true));
    dispatch(streamActions.setAudioMuteState(mute));
  }
});

function mapStateToProps(state) {
  const activeCall = callSelectors.activeCallSelector(state);
  const isWebConferencing = _get(activeCall, 'isWebConferencing');
  const isMutedByServer = _get(activeCall, 'isMutedByServer');
  const isAudioMuted = _get(activeCall, 'isAudioMuted');
  const isConnected = isCallConnected(activeCall);
  const isMinimized = _get(state, 'app.inCallVideo.isMinimized');
  const notification = _get(state, 'app.notification.pill');
  const hasAudioDevices = mediaSelectors.audioDevices(state).length !== 0;
  const microphoneDeviceId = _get(mediaSelectors.selectedAudioDevice(state), 'deviceId');
  const isModerator = _get(activeCall, 'isModerator', false);

  return {
    isConnected,
    isWebConferencing,
    isMinimized,
    isMutedByServer,
    notification,
    isAudioMuted,
    hasAudioDevices,
    microphoneDeviceId,
    isModerator
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AudioButton);
